/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Loader} from 'react-overlay-loader';
import {Redirect} from 'react-router-dom';
import xosphereLogo from '../../assets/images/xosphere-logo.png';
import * as actions from '../../store/actions';
import Error from '../../components/UI/Error';

class LoginPw extends Component {
    state = {
        password: "",
        redirectToForgotPassword: false,
        showPassword: false,
    };

    backToEmail = (event) => {
        event.preventDefault()
        this.setState({beackToEmail: true})
    };

    handleSubmit = (event) => {
        event.preventDefault();
        this.props.onLogin(this.props.email, this.state.password)
    };

    handlePasswordChange = (event) => {
        this.setState({password: event.target.value.trim()})
    };

    togglePassword = (event) => {
        event.preventDefault();
        let showPw = this.state.showPassword;
        this.setState({showPassword: !showPw});
    };

    handleForgotPassword = (event) => {
        event.preventDefault();
        this.setState({redirectToForgotPassword: true})
    };


    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.props.onLogin(this.props.email, this.state.password)
        }
    };

    render() {
        let redirect = null;
        if (this.state.redirectToForgotPassword) {
            redirect = <Redirect to={{pathname: '/forgotPassword'}}/>
        }
        if (this.state.beackToEmail) {
            redirect= <Redirect to={{pathname: '/login', search: 'backToLogin=true'}}/>
        }
        if (this.props.isAuthenticated && !this.props.gcpOnly) {
            redirect = <Redirect to={{pathname: '/dashboard'}}/>
        } else if (this.props.isAuthenticated && this.props.gcpOnly) {
            redirect = <Redirect to={{pathname: '/gcpDashboard'}}/>
        } else if (this.props.isAuthenticated) {
            redirect = <Redirect to={{pathname: '/dashboard'}}/>
        }
        let passwordInput = null;
        if (this.state.showPassword) {
            passwordInput =
                <input type="text" className="form-control" id="password" placeholder="Password" autoComplete="current-password" value={this.state.password} autoFocus
                       onChange={this.handlePasswordChange} onKeyPress={e => this.handleKeyPress(e)}/>
        } else {
            passwordInput =
                <input type="password" className="form-control" id="password" placeholder="Password" autoComplete="current-password" value={this.state.password} autoFocus
                       onChange={this.handlePasswordChange} onKeyPress={e => this.handleKeyPress(e)}/>
        }
        return (
            <div className="container-fluid">
                {redirect}
                <Loader fullPage={true} loading={this.props.loading}/>
                <div className="row justify-content-md-center">
                    <div className="col-lg-10 col-md-12 text-center">
                        <div className="row justify-content-sm-center login-top">
                            <div className="col-lg-4 col-md-5 col-sm-7 text-center"><img
                                src={xosphereLogo} alt="" title="" className="mb-4"/>
                                <Error errorMsg={this.props.error} divClass="col-lg-5 col-sm-6 col-center"/>

                                <div className="form-group">
                                    <div>You are signing in with</div>
                                    <div><b>{this.props.email}</b></div>
                                    <div>
                                        <a href="#" onClick={this.backToEmail}>Use different account</a>
                                    </div>
                                </div>
                                <div className="form-group row no-gutters">
                                    <div className="col-11">
                                        <input type="email" autoComplete="username" id="login" defaultValue={this.props.email} hidden="{true}" />
                                        {passwordInput}
                                    </div>
                                    <div className="col-1">
                                        <div className="mt-2"><a href="#" className="gray"
                                                                 onClick={this.togglePassword}><i
                                            className="fa fa-eye"></i></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group row no-gutters">
                                    <div className="col-11 text-right"><a href="forgot-password.html"
                                                                          onClick={this.handleForgotPassword}
                                                                          className="btn-link">Forgot Password?</a>
                                    </div>
                                    <div className="col-1"></div>
                                </div>
                                <div className="form-group mb-5">
                                    <input type="submit" value="Log In" className="btn btn-primary"
                                           onClick={this.handleSubmit}></input>
                                </div>
                                {
                                    (this.props.redirect) ? (
                                    <div className="form-group">Login with your <a href={this.props.redirect}>SSO Identity Provider</a></div>
                                    ) : null
                                }

                                <div className="form-group"> Don't have an account? <a href="#"
                                                                                       onClick={this.handleSignup}
                                                                                       className="btn-link">Signup</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        loading: state.login.loading,
        error: state.login.error,
        isAuthenticated: state.login.token !== null,
        email: state.login.email,
        hasGcp: state.login.hasGcp,
        gcpOnly: state.login.gcpOnly,
        redirect: state.login.redirect,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onLogin: (email, password) => dispatch(actions.login(email, password))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPw);
